import { SVGAttributes } from "react";

const CardPlusIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="10.5"
        cy="10.5"
        r="9"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 10.5H13.875"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5055 7.13062L10.5055 13.8806"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CardPlusIcon;
